import { RegularFilterValueConfig } from '@empathybroker/tsclient-play/dist/models/instance/filters/regular-filter-value-config';

import { FilterTypeEnum } from '../../../enums';

import { ContextState, DateFilter, Filter, GetterClass, RealtimeFilter, RegularFilter } from '../../../models';

export class FiltersAreValidGetter implements GetterClass {

  public static execute(state: ContextState): boolean {
    return Object.values(state.filters).every((filter: Filter) => {
      if (!filter.config.enabled) {
        return true;
      }
      return {
        [FilterTypeEnum.DATE]: () => FiltersAreValidGetter.isDateFilterValid(filter as DateFilter),
        [FilterTypeEnum.REALTIME]: () => FiltersAreValidGetter.isRealtimeFilterValid(filter as RealtimeFilter),
        [FilterTypeEnum.REGULAR]: () => FiltersAreValidGetter.isRegularFilterValid(filter as RegularFilter)
      }[filter.config.type]();
    });
  }

  private static isDateFilterValid(filter: DateFilter): boolean {
    const startDateInMillis = filter.selectedValues[0];
    const endDateInMillis = filter.selectedValues[1];
    if (filter.config.mandatory && (!startDateInMillis || !endDateInMillis)) {
      return false;
    }
    const startDateIsValid = (!startDateInMillis ||
      (!filter.config.minDateInMillis || (startDateInMillis >= filter.config.minDateInMillis)));
    const endDateIsValid = (!endDateInMillis || (!filter.config.maxDateInMillis || (endDateInMillis <= filter.config.maxDateInMillis)));
    const periodDurationInMillis = (endDateInMillis - startDateInMillis);
    const periodIsValid = ((periodDurationInMillis > 0) &&
      (!filter.config.minPeriodInMillis || (periodDurationInMillis >= filter.config.minPeriodInMillis)) &&
      (!filter.config.maxPeriodInMillis || (periodDurationInMillis <= filter.config.maxPeriodInMillis)));
    return (startDateIsValid && endDateIsValid && periodIsValid);
  }

  private static isRealtimeFilterValid(filter: RealtimeFilter): boolean {
    if (filter.config.mandatory && !filter.selectedValues) {
      return false;
    }
    return (filter.config.intervalsInMinutes.indexOf(filter.selectedValues) >= 0);
  }

  private static isRegularFilterValid(filter: RegularFilter): boolean {
    if (filter.config.mandatory && (filter.selectedValues.length === 0)) {
      return false;
    }
    if (filter.config.multiselectDisabled && (filter.selectedValues.length > 1)) {
      return false;
    }
    return filter.selectedValues.every((selectedValueId: string) =>
      (filter.config.values.some((valueConfig: RegularFilterValueConfig) => (valueConfig.id === selectedValueId))));
  }

}
